import React, { memo } from 'react';
import { Typography, Stack, Divider, Icon } from 'investira.react.components';

const FooterTemplate = memo(props => {
  const {
    variant = 'default' // default | avaliacao
  } = props;

  const xCurrentYear = new Date().getFullYear();

  return (
    <Stack pt={4}>
      <Divider />
      <Stack py={2}>
        {variant === 'default' && (
          <Typography variant="caption" color="textSecondary" gutterBottom>
            O app.investira.biz tem caráter exclusivamente informativo e educativo, utilizando dados
            de fontes oficiais como B3, CVM e Tesouro Nacional. Não fornecemos recomendações de
            compra ou venda de ativos, e não nos responsabilizamos por decisões tomadas com base em
            nossas informações. Alguns dados fornecidos neste site podem ser processados com o
            auxílio de inteligência artificial (IA). Embora nos esforcemos para garantir a precisão
            e confiabilidade das informações, não nos responsabilizamos por eventuais erros ou
            inconsistências decorrentes do uso de IA. Recomendamos que os usuários verifiquem e
            validem as informações conforme necessário para suas finalidades específicas. O uso dos
            dados é de responsabilidade exclusiva do usuário.
          </Typography>
        )}

        {variant === 'default' && (
          <Typography variant="caption" color="textSecondary" gutterBottom>
            Conheça mais:{' '}
            <Typography
              component="a"
              href="https://investira.com.br"
              target="_blank"
              rel="noopener noreferrer"
              color="primary"
              variant="caption">
              investira.com.br
            </Typography>{' '}
            |{' '}
            <Typography
              component="a"
              href="https://investira.biz"
              target="_blank"
              rel="noopener noreferrer"
              color="primary"
              variant="caption">
              investira.biz
            </Typography>{' '}
            |{' '}
            <Typography
              component="a"
              href="https://investira.pro"
              target="_blank"
              rel="noopener noreferrer"
              color="primary"
              variant="caption">
              investira.pro
            </Typography>{' '}
            |{' '}
            <Typography
              component="a"
              href="https://investira.vc"
              target="_blank"
              rel="noopener noreferrer"
              color="primary"
              variant="caption">
              investira.vc
            </Typography>
          </Typography>
        )}

        {variant === 'default' && (
          <Typography variant="caption" color="textSecondary">
            Copyright © {xCurrentYear} investira. Todos os direitos reservados.
          </Typography>
        )}

        {variant === 'avaliacao' && (
          <Stack direction="row" gap={2}>
            <Icon iconName="investira_icon" size={21} color="greenLight" />
            <Typography variant="caption" color="textSecondary">
              Desenvolvido por investira. Todos os direitos reservados.
            </Typography>
          </Stack>
        )}
      </Stack>
    </Stack>
  );
});

export default FooterTemplate;
